import { BLOG_COLLECTION_PATH, BLOG_POST_PATH_PREFIX } from "@/lib/seo/metadata";

const stripQueryAndHash = (value: string) => value.split(/[?#]/, 1)[0] || value;

/** Public blog post detail route (`/p/:slug`). */
export const isBlogPostDetailPath = (pathname: string): boolean => {
  const normalized = stripQueryAndHash(pathname);
  return (
    normalized.startsWith(BLOG_POST_PATH_PREFIX) &&
    normalized.length > BLOG_POST_PATH_PREFIX.length
  );
};

/** Public blog surfaces that must not wait on signed-in entitlement bootstrap. */
export const isPublicBlogPath = (pathname: string): boolean => {
  const normalized = stripQueryAndHash(pathname);
  return normalized === BLOG_COLLECTION_PATH || isBlogPostDetailPath(normalized);
};
